import Header from "../components/Header";

const MainLayout = ({
  children,
  language,
  toggleLanguage,
  activeSection,
  scrollToSection,
}) => {
  return (
    <>
      <Header
        language={language}
        toggleLanguage={toggleLanguage}
        activeSection={activeSection}
        scrollToSection={scrollToSection}
      />
      {children}
    </>
  );
};

export default MainLayout;
